import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "columns is-multiline" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_8 = {
  key: 0,
  class: "field"
}
const _hoisted_9 = { class: "columns is-mobile is-align-items-center is-gapless" }
const _hoisted_10 = { class: "column is-narrow" }
const _hoisted_11 = { class: "label mr-2" }
const _hoisted_12 = { class: "column is-flex is-align-items-center" }
const _hoisted_13 = { class: "column is-narrow" }
const _hoisted_14 = { class: "column is-narrow" }
const _hoisted_15 = {
  key: 0,
  class: "help is-danger input-error"
}
const _hoisted_16 = {
  key: 1,
  class: "help is-success input-success"
}
const _hoisted_17 = {
  key: 1,
  class: "field is-grouped is-align-items-center",
  style: {"width":"100%"}
}
const _hoisted_18 = { class: "label mt-0 mr-2" }
const _hoisted_19 = { class: "control is-expanded" }
const _hoisted_20 = { class: "select is-fullwidth" }
const _hoisted_21 = { value: "" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "control" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 2,
  class: "field is-flex is-align-items-center"
}
const _hoisted_26 = { class: "label mt-0 mr-2" }
const _hoisted_27 = {
  key: 0,
  class: "control is-flex-grow-1"
}
const _hoisted_28 = { class: "select is-fullwidth" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { class: "label mt-4" }
const _hoisted_34 = { class: "control" }
const _hoisted_35 = {
  key: 4,
  class: "field"
}
const _hoisted_36 = { class: "label mt-0" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = ["placeholder", "disabled"]
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { class: "label mt-4" }
const _hoisted_41 = { class: "control mb-4" }
const _hoisted_42 = {
  key: 6,
  class: "field"
}
const _hoisted_43 = { class: "field is-flex is-align-items-center" }
const _hoisted_44 = { class: "label mt-3 mr-2" }
const _hoisted_45 = { class: "control is-flex-grow-1" }
const _hoisted_46 = { class: "ml-2" }
const _hoisted_47 = ["data-tooltip"]
const _hoisted_48 = { class: "label mt-3" }
const _hoisted_49 = { class: "control" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "is-hidden-desktop my-4 card p-2"
}
const _hoisted_53 = { class: "px-3 py-3 is-size-5 has-text-weight-semibold" }
const _hoisted_54 = { class: "is-flex" }
const _hoisted_55 = { class: "is-flex-grow-1" }
const _hoisted_56 = { class: "image is-128x128" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "subtitle is-flex is-flex-direction-column is-justify-content-center" }
const _hoisted_59 = { class: "is-size-6 has-text-weight-semibold has-text-grey-dark" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "checkbox mt-0" }
const _hoisted_62 = ["href"]
const _hoisted_63 = ["href"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "checkbox mt-0" }
const _hoisted_66 = ["href"]
const _hoisted_67 = {
  key: 9,
  class: "has-text-centered"
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = ["action"]
const _hoisted_70 = {
  key: 1,
  class: "field mt-4"
}
const _hoisted_71 = { class: "label" }
const _hoisted_72 = {
  key: 2,
  class: "card"
}
const _hoisted_73 = { class: "is-flex is-align-items-center" }
const _hoisted_74 = { class: "image is-128x128" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "is-flex is-flex-direction-column" }
const _hoisted_77 = { class: "is-size-5 has-text-grey-dark" }
const _hoisted_78 = {
  key: 3,
  class: "has-text-centered mt-4"
}
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  class: "image mb-1",
  style: {"width":"90%","height":"auto"}
}
const _hoisted_81 = ["src"]
const _hoisted_82 = {
  key: 1,
  class: "card is-hidden-mobile"
}
const _hoisted_83 = { class: "card-header mt-0 mb-0 px-2 py-1 is-size-5 has-text-weight-bold" }
const _hoisted_84 = { class: "card-header-title" }
const _hoisted_85 = { class: "card-content is-flex is-align-items-center mt-0 mb-0 py-1 px-2" }
const _hoisted_86 = { class: "media" }
const _hoisted_87 = { class: "media-left" }
const _hoisted_88 = { class: "image is-128x128 mt-0 mb-1 py-1 px-0" }
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "media-content mt-0 mb-1" }
const _hoisted_91 = { class: "title is-4 py-1 px-1" }
const _hoisted_92 = { class: "subtitle is-6 py-1 px-1" }
const _hoisted_93 = { key: 2 }
const _hoisted_94 = {
  key: 0,
  class: "scheduler-container is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_95 = { class: "image-container" }
const _hoisted_96 = { class: "is-flex is-flex-direction-column is-justify-content-center" }
const _hoisted_97 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'column': true, 'is-6': !_ctx.getSchedulingAppointment, 'is-4': _ctx.getSchedulingAppointment, 'is-full-mobile': true })
              }, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Customer.VideoAppointment')), 1),
                (!_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.$t('Customer.TalkFavoriteVet')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  class: "column is-flex is-flex-direction-column is-justify-content-center",
                  onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scheduleAppointment && _ctx.scheduleAppointment(...args)), ["prevent"]))
                }, [
                  (_ctx.useAppointsAccessCodes && !_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Customer.EnterAppointmentsAccessCode')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "input mr-2",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getNewAppointmentData.appointmentCode) = $event)),
                              required: ""
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.getNewAppointmentData.appointmentCode,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitCode && _ctx.submitCode(...args))),
                              class: "button is-small is-primary mr-2"
                            }, _toDisplayString(_ctx.$t('Customer.SubmitCode')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.getNewAppointmentData.codeValidationError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('Customer.InvalidAccessCode')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.getNewAppointmentData.isCodeValid)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('Customer.ValidAccessCode')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('Customer.Specialty')), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getNewAppointmentData.specialtyId) = $event)),
                              required: "",
                              class: "px-6"
                            }, [
                              _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('Customer.SelectSpecialty')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSpecialties, (specialty) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: specialty.specialty_id,
                                  value: specialty.specialty_id
                                }, _toDisplayString(specialty.name), 9, _hoisted_22))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.getNewAppointmentData.specialtyId]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            class: "button is-primary mt-mobile-3",
                            disabled: !_ctx.getNewAppointmentData.specialtyId,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleShowDetails && _ctx.handleShowDetails(...args)))
                          }, _toDisplayString(_ctx.$t('Customer.SpecialtyContents')), 9, _hoisted_24)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('Customer.PetName')), 1),
                        (_ctx.getCustomerHasPets)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.getNewAppointmentData.petId) = $event)),
                                  required: "",
                                  class: "px-6"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEditedCustomerPets, (pet) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: pet.pet_id,
                                      value: pet.pet_id
                                    }, _toDisplayString(pet.name) + " / " + _toDisplayString(pet.owner), 9, _hoisted_29))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.getNewAppointmentData.petId]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", {
                                class: "notification is-danger is-light is-small",
                                innerHTML: _ctx.$t('CustomerData.PleaseAddPets'),
                                style: {"padding":"0.5rem","margin":"0.5rem 0"}
                              }, null, 8, _hoisted_31)
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('Customer.PetName')), 1),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedPetName), 1)
                        ])
                      ])),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Customer.ChiefComplaint')), 1),
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("textarea", {
                            class: "textarea",
                            placeholder: _ctx.$t('Customer.DescChiefComplaint'),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getNewAppointmentData.description) = $event)),
                            required: "",
                            disabled: !_ctx.getCustomerHasPets
                          }, null, 8, _hoisted_38), [
                            [
                              _vModelText,
                              _ctx.getNewAppointmentData.description,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('Customer.ChiefComplaint')), 1),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.getNewAppointmentData.description), 1)
                        ])
                      ])),
                  _createVNode(_component_FileInput, {
                    ref: "fileInput",
                    onFileChange: _ctx.handleFileUpload,
                    disabled: _ctx.isLoadingPaymentForm
                  }, null, 8, ["onFileChange", "disabled"]),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('Customer.SelectSchedulingDate')), 1),
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_VueDatePicker, {
                              id: "scheduling_date",
                              modelValue: _ctx.getNewAppointmentData.schedulingDate,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.getNewAppointmentData.schedulingDate) = $event)),
                              placeholder: _ctx.$t('General.PleaseSelectDate'),
                              "model-type": "yyyy-MM-dd",
                              "auto-apply": "",
                              "min-date": new Date(),
                              "max-date": _ctx.maxDate,
                              "enable-time-picker": false,
                              "prevent-min-max-navigation": "",
                              format: "yyyy-MM-dd"
                            }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", {
                              class: "icon has-tooltip-arrow has-tooltip-right",
                              "data-tooltip": _ctx.$t('Customer.SchedulingDateHelp')
                            }, _cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "fas fa-info-circle has-text-success" }, null, -1)
                            ]), 8, _hoisted_47)
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('Customer.SelectVetSpecialist')), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["select is-fullwidth", { 'is-loading': _ctx.vetsListLoading }])
                          }, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getNewAppointmentData.vetUserId) = $event)),
                              required: "",
                              class: "px-6",
                              disabled: !_ctx.getCustomerHasPets,
                              onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkAvailableVets && _ctx.checkAvailableVets(...args)))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableVets, (vet) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: vet.user_id,
                                  value: vet.user_id
                                }, _toDisplayString(vet.name), 9, _hoisted_51))
                              }), 128))
                            ], 40, _hoisted_50), [
                              [_vModelSelect, _ctx.getNewAppointmentData.vetUserId]
                            ])
                          ], 2)
                        ]),
                        (_ctx.getNewAppointmentData.vetUserId > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('Customer.ImYourSpecialist')), 1),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("figure", _hoisted_56, [
                                    _createElementVNode("img", {
                                      class: "is-rounded",
                                      src: _ctx.specialistProfileImageURL,
                                      alt: "no_profile_image"
                                    }, null, 8, _hoisted_57)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.requestedVetData[0].name), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 7,
                        class: "field",
                        disabled: !_ctx.getCustomerHasPets
                      }, [
                        _createElementVNode("label", _hoisted_61, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getNewAppointmentData.gdprChecked) = $event)),
                            required: ""
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.getNewAppointmentData.gdprChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.GDPRPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.gdprTermsUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.GDPRLink')), 9, _hoisted_62),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TermsPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.termsUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.TermsLink')), 9, _hoisted_63)
                        ])
                      ], 8, _hoisted_60))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 8,
                        class: "field",
                        disabled: !_ctx.getCustomerHasPets
                      }, [
                        _createElementVNode("label", _hoisted_65, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.getNewAppointmentData.telemedicineAuthChecked) = $event)),
                            required: ""
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.getNewAppointmentData.telemedicineAuthChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TelemedicineAuthPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.authPrevUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.TelemedicineAuthLink')), 9, _hoisted_66),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TelemedicineAuthNext')), 1)
                        ])
                      ], 8, _hoisted_64))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isCreatingAppointment }]),
                          disabled:  !_ctx.getNewAppointmentData.gdprChecked ||
                                            !_ctx.getNewAppointmentData.telemedicineAuthChecked ||
                                            !_ctx.getCustomerHasPets ||
                                            (_ctx.useAppointsAccessCodes && !_ctx.getNewAppointmentData.isCodeValid)
                        }, _toDisplayString(_ctx.$t('Customer.ScheduleAppointment')), 11, _hoisted_68)
                      ]))
                    : _createCommentVNode("", true)
                ], 32),
                _createElementVNode("form", {
                  class: "hidden",
                  action: _ctx.getPaymentEndpoint(),
                  method: "POST",
                  id: "paymentForm"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "payment_hash",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.paymentHash) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.paymentHash]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "payment_email",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.paymentEmail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.paymentEmail]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "customer_user_id",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.getNewAppointmentData.customerUserId) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.getNewAppointmentData.customerUserId]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "auth_token",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.authToken) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.authToken]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "ga_client_id",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.gaClientId) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.gaClientId]
                  ])
                ], 8, _hoisted_69),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('Customer.VetSpecialist')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("figure", _hoisted_74, [
                          _createElementVNode("img", {
                            class: "is-rounded",
                            src: _ctx.specialistProfileImageURL,
                            alt: "no_profile_image"
                          }, null, 8, _hoisted_75)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.requestedVetData[0].name), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("button", {
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.endScheduleAppointment && _ctx.endScheduleAppointment(...args))),
                        class: "button is-primary",
                        disabled: _ctx.isLoadingPaymentForm
                      }, _toDisplayString(_ctx.$t('General.Back')), 9, _hoisted_79)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ 'column': true, 'is-hidden-mobile': !_ctx.getSchedulingAppointment, 'is-6': !_ctx.getSchedulingAppointment, 'is-8': _ctx.getSchedulingAppointment, 'is-flex': true, 'is-flex-direction-column': true, 'is-align-items-center': true })
              }, [
                (!_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("figure", _hoisted_80, [
                      _createElementVNode("img", {
                        src: _ctx.imagePath,
                        alt: "cat"
                      }, null, 8, _hoisted_81)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getNewAppointmentData.vetUserId > 0 && !_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$t('Customer.ImYourSpecialist')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("figure", _hoisted_88, [
                              _createElementVNode("img", {
                                class: "is-rounded",
                                src: _ctx.specialistProfileImageURL,
                                alt: "no_profile_image"
                              }, null, 8, _hoisted_89)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.requestedVetData[0].name), 1),
                            _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.$t('Customer.LetsSolveTogether')), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      (_ctx.isLoadingPaymentForm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: "https://i.imgur.com/uA3fRLZ.png",
                                  class: "image is-fullwidth",
                                  alt: "logo"
                                })
                              ], -1)),
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('Customer.WaitForPayment')), 1),
                                _cache[19] || (_cache[19] = _createElementVNode("progress", { class: "progress is-primary" }, null, -1))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("iframe", {
                            key: 1,
                            id: "AppointmentScheduler",
                            src: _ctx.iframeSrc,
                            class: "scheduler-container",
                            style: {"padding":"0","overflow-y":"hidden","overflow-x":"hidden"}
                          }, null, 8, _hoisted_97))
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}